export enum SideNoteTypeEnum {
    None = -1,
    TechnologyNote = 0,
    RadarNote = 1,
    IntakeNote = 2,
    MidwayTableNote = 3,
    FinalTableNote = 4
}